import uniqueId from 'lodash/uniqueId';

import { clock } from '@/services/clock';
import type { AIMessage, ContentPart, Message } from '../types/chat.types';

// Pure function to append a content part to message
export function appendPartToMessages(
  prev: Message[],
  part: ContentPart,
  timestamp = clock.date().toISOString()
): Message[] {
  const next = [...prev];
  const last = next.at(-1);
  const now = timestamp;
  if (last?.sender !== 'ai') {
    const ai: AIMessage = {
      id: uniqueId(now),
      sender: 'ai',
      timestamp: now,
      content: [part]
    };
    next.push(ai);
    return next;
  }
  const ai = { ...last } as AIMessage;
  const lastPart = ai.content.at(-1);
  if (part.kind === 'text' && lastPart?.kind === 'text') {
    ai.content = [...ai.content.slice(0, -1), { kind: 'text', text: lastPart.text + part.text }];
  } else {
    ai.content = [...ai.content, part];
  }
  next.splice(-1, 1, ai);
  return next;
}
